import { clearFilters } from "../actions/filter/clearFilters";
import schedulesViewStateStore from "../store/store";
import setIsProgressiveRendering from "sh-application/components/schedules/lib/actions/setIsProgressiveRendering";
import updateIsDataInDateRangeLoaded from "../mutators/updateIsDataInDateRangeLoaded";
import clearScheduleDataInView from "../actions/clearScheduleDataInView";
import {
    setConflictCountInView,
    setConflictsInView,
    setDatesWithNewEdits,
    setIsConflictCalculationInProgress,
    setIsViewStatePopulated,
    setNewlyEditedEntities,
    setNotesInView,
    setOpenShiftsInView,
    setShiftsInView
    } from "../index";
import { IBaseConflictEntity } from "sh-models";
import { ObservableMap } from "mobx";
import { orchestrator } from "satcheljs";

/**
 * Clear schedule data in view. Currently this consists of shifts, open shifts, notes and conflicts.
 */

 export const clearScheduleDataInViewOrchestrator = orchestrator(clearScheduleDataInView, actionMessage => {
    const { viewState, clearIsViewStatePopulated } = actionMessage;
        setIsProgressiveRendering(false, false /* didComplete */, viewState);
        setShiftsInView([], viewState);
        clearFilters(true /* shouldClearLabel */, viewState);
        setOpenShiftsInView([], viewState);
        setNotesInView([], viewState);
        setNewlyEditedEntities([], false /* isNewlyEdited */, viewState);
        setDatesWithNewEdits([], false /* hasNewEdit */, viewState);
        updateIsDataInDateRangeLoaded(false, viewState);
        if (actionMessage.clearIsViewStatePopulated) {
            setIsViewStatePopulated(false, viewState);
        }
        setIsConflictCalculationInProgress(false, viewState);
        setConflictCountInView(0, 0, viewState);
        setConflictsInView(new ObservableMap<string, IBaseConflictEntity[]>(), viewState);
    }
);